"use client"

import { useState } from "react"
import Header from "./Header"
import { Link } from "react-router-dom"
import VideoModal from "../Shared/VideoModal"

const Hero = () => {
  const [isModalOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  return (
    <div
      className="mt-4 md:mt-0 relative bg-cover bg-center h-[95vh] w-full pb-6"
      style={{ backgroundImage: "url(/images/background.png)" }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40 pointer-events-none"></div>

      <Header className="absolute top-0 left-0 w-full" />

      <div className="relative flex flex-col items-center justify-start h-full space-y-4 md:space-y-6 mt-[35%] md:mt-[6%] px-4">
        <h1 className="relative text-white text-center mb-[-0.17em] leading-[1em] text-[28px] sm:text-[32px] lg:text-[96px] font-semibold">
          THRIVE IN NATURE.
        </h1>
        <p className="pt-2 md:pt-3 text-[#f6f4ef] text-[14px] sm:text-[16px] md:text-[18px] text-center font-light italic px-2">
          Wellness retreats & lux stays <br />@ Leafwell Farm.
        </p>
        <div className="flex flex-col md:flex-row gap-3 lg:gap-16 justify-center items-center w-full max-w-md md:max-w-none">
          <Link to="/booking?event=leafwell-nature-stay" className="w-full md:w-auto">
            <button className="w-full md:min-w-[125px] bg-white text-black rounded-full px-8 md:px-16 py-3.5 md:py-4 text-[14px] md:text-[18px] font-semibold uppercase">
              BOOK NOW
            </button>
          </Link>
          <button
            onClick={openModal}
            className="w-full md:w-auto md:min-w-[125px] text-[#1b1b1b] bg-white rounded-full px-8 md:px-16 py-3.5 md:py-4 text-[14px] md:text-[18px] font-semibold uppercase"
          >
            VIEW
          </button>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full flex justify-center mb-4">
        <a href="/" className="link-circle">
          <img src="/icons/down_arrow.svg" alt="" className="" />
        </a>
      </div>

      <VideoModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  )
}

export default Hero
